import { useState } from 'react'
import { useRouter } from 'next/router'
import { Button } from 'design-system/ui/atoms/button'
import { PlusIcon } from 'lucide-react'

import type { GetAuthConfigsByNanoidResponse } from '~/generated/client'
import { E2EFlowWizard } from '~/ui/screens/appScreen/modules/wizard'

export const AddAccountButton = ({
  connectorData,
  isMountedAtTop = false,
}: {
  connectorData: GetAuthConfigsByNanoidResponse
  buttonVariant?: 'default' | 'plain'
  size?: 32 | 40
  isMountedAtTop?: boolean
}) => {
  const { query } = useRouter()
  const [show, setShow] = useState(
    query.addConnectorWizard === 'true' && isMountedAtTop,
  )

  return (
    <>
      <div
        className="flex  items-center gap-3"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <Button
          variant="primary"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setShow(true)
          }}
          size="36"
          className=" flex  items-center justify-center rounded-[10px]  "
        >
          <PlusIcon className="mr-1" height={14} width={14} />
          Add account
        </Button>
      </div>
      {show && (
        <E2EFlowWizard
          initialData={{
            first: {
              appName: connectorData?.toolkit?.slug || '',
            },
            second: {
              authConfigId: connectorData?.id || null,
            },
            third: {
              connectedAccountId: null,
              actionName: null,
            },
            currentStep: 2,
          }}
          setOpen={(e) => {
            setShow(e)
          }}
        />
      )}
    </>
  )
}
